<template>
  <div class="has-text-left container" :class="getUserType == 0 ? 'margin-flag-b2c-select2' : ''">
    <div class="bread_crumbs-4">
      <div class="bread_crumbs-item" @click="clickBreadCrumbs(1)">
        <div class="jugadores avenirnextltpro-medium-big-stone-19-4px">
          Jugadores - Equipo
        </div>
      </div>
      <div class="division-4"><div class="text-3 avenirnextltpro-demi-normal-big-stone-19-4px">/</div></div>
      <div class="bread_crumbs-item">
        <div class="perfil-jugador-4">Jugadores - Plantilla</div>
      </div>
    </div>
    <CentralItemsContainer hint="">
      <PlayerItem v-for="player in players" :key="player.id" :player="player" @click="onPlayerItemClicked" />
    </CentralItemsContainer>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CentralItemsContainer from '@/components/Elements/CentralItemsContainer';
import PlayerItem from '@/components/Elements/PlayerItem';
import { analisisDeJugador } from '@/utils/analytics/players';
import { getLocalStorageSeasonSelected } from '@/utils/misc';

export default {
  name: 'Players',
  components: {
    PlayerItem,
    CentralItemsContainer,
  },
  computed: {
    ...mapGetters('loginGeneral', ['seasonId', 'getUserType']),
    ...mapState('playersGeneral', { players: 'lastPlayersForPlayersView' }),
    teamId() {
      return Number(this.$route.params.teamId) || 0;
    },
  },
  async mounted() {
    try {
      window.scrollTo(0, 0);

      await this.$store.dispatch('playersGeneral/getPlayersForPlayersView', {
        teamId: this.$route.params.teamId,
        name: this.$route.query.teamName,
      });
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    onPlayerItemClicked(playerId) {
      analisisDeJugador(this.teamId, playerId);
      this.$router.push({
        name: 'player',
        params: { seasonId: getLocalStorageSeasonSelected() || this.seasonId, playerId: playerId },
      });
    },
    clickBreadCrumbs(id) {
      if (id == 1) {
        this.$router.push('/playersAnalysis/teams');
      }
    },
  },
};
</script>
<style>
.margin-flag-b2c-select2 {
  margin-bottom: 90px !important;
}
.division-4 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 19.35px;
  padding: 3.87px;
  position: relative;
  width: fit-content;
}

.text-3 {
  letter-spacing: -0.19px;
  line-height: 32.9px;
  margin-top: -3.87px;
  opacity: 0.4;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}
@media screen and (max-width: 1408px) {
  .text-3 {
    font-size: 10px !important;
  }
}
.page-title {
  text-transform: uppercase;
}
.bread_crumbs-4 {
  align-items: center;
  display: flex;
  justify-content: left;
  padding: 0px 0px 0px 7.74px;
  position: relative;
  width: 1270px;
  height: 80px;
  margin: 0 auto;
}
@media screen and (max-width: 1408px) {
  .bread_crumbs-4 {
    align-items: center;
    display: flex;
    justify-content: left;
    padding: 0px 0px 0px 7.74px;
    position: relative;
    width: 1140px;
    height: 60px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 1216px) {
  .bread_crumbs-4 {
    align-items: center;
    display: flex;
    justify-content: left;
    padding: 0px 0px 0px 7.74px;
    position: relative;
    width: 940px;
    height: 50px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 1024px) {
  .bread_crumbs-4 {
    align-items: center;
    display: flex;
    justify-content: left;
    padding: 0px 0px 0px 7.74px;
    position: relative;
    width: 96%;
    height: 40px;
    margin: 0 auto;
  }
}

.bread_crumbs-item {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 19.35px;
  padding: 3.87px 7.74px;
  position: relative;
  width: fit-content;
}

.jugadores {
  letter-spacing: -0.19px;
  line-height: 32.9px;
  margin-top: -3.87px;
  position: relative;
  text-align: center;
  text-decoration: underline;
  white-space: nowrap;
  width: fit-content;
}
@media screen and (max-width: 1408px) {
  .jugadores {
    font-size: 10px !important;
  }
}
.jugadores:hover {
  color: #23b0ff;
  cursor: pointer;
}

.perfil-jugador-4 {
  color: var(--big-stone);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: var(--font-size-xxxl);
  font-weight: 700;
  letter-spacing: -0.19px;
  line-height: 32.9px;
  margin-top: -3.87px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}
@media screen and (max-width: 1408px) {
  .perfil-jugador-4 {
    font-size: 10px !important;
  }
}
</style>
